var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"select-indicator tw-flex tw-items-center tw-justify-center tw-bg-white tw-border-solid tw-border tw-rounded-full",class:{
    'tw-bg-grey-800 tw-border-white tw-text-white': _vm.selected,
    'tw-border-grey-800': !_vm.selected
  }},[(_vm.selected)?_c('span',{staticClass:"tw-icon tw-icon-haken-bold"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }